import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import ReactFileReader from 'react-file-reader';

const UploadFile = ({
    field: { name, value},
    form: { touched, errors, setFieldValue },
    size,
    ...props
}) => {
    return (
        <>
            <ReactFileReader base64={true} fileTypes={props.typer}
                handleFiles={(value) => setFieldValue(name, value)}
                {...props}
            >
                <Button color={props.clrd} size={size} basic type='button'  icon labelPosition="right" >
                    {props.buttonName}
                    <Icon name="file pdf" color="red" />
                </Button>
            </ReactFileReader>
        </>

    )
}

export default UploadFile